import { render } from "./FormatName.vue?vue&type=template&id=668cba32&ts=true"
import script from "./FormatName.vue?vue&type=script&lang=ts"
export * from "./FormatName.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__